<div
  class="flex items-center gap-2.5 pb-4"
  *ngIf="showSearch || showButtonAddActionplan || isViewMode"
>

  @if (showButtonAddActionplan && !isViewMode) {
    <button
      svc-filled-btn-icon
      class="max-h-6 max-w-6 rounded-full bg-transparent"
      color="on-primary"
      id="svc-actionplan-button-add"
      icon="heroicons_solid:plus-circle"
      [iconSize]="6"
      (click)="openDialogActionPlan()"
    ></button>
  }

  <div
    class="w-full max-w-[420px] print:hidden"
    *ngIf="showSearch"
  >
    <svc-search-field
      [forceWidthFull]="true"
      [disabled]="isLoading"
      (onChanged)="filterActionsPlans($event)"
    />
  </div>
</div>

<div
  class="text-center text-sm text-default"
  *ngIf="!isLoading && !actionsPlans?.length"
>
  {{ 'Nenhum resultado encontrado' | transloco }}
</div>

<div
  class="flex flex-col gap-1"
  *ngIf="!isLoading || actionsPlans?.length"
>
  <div
    class="action-plan flex gap-1 justify-between items-center px-2 cursor-pointer border-gray-300"
    [class.border-b]="actionsPlans[actionsPlans.length - 1] !== actionPlan"
    id="svc-actionplan-card"
    *ngFor="let actionPlan of actionsPlans"
    (click)="openDialogActionPlan(actionPlan, false)"
  >
    <div class="flex gap-1 justify-between items-center w-full py-2.5">
      <div class="flex gap-1.5 items-center">
        <div class="flex gap-2">
          <div class="h-5 w-5">
            <svc-lock-button
              *ngIf="actionPlan?.classified"
              iconSizeClass="icon-size-5"
              [locked]="!actionPlan?.allowed"
              [readonly]="true"
            />
          </div>

          <div [matTooltip]="actionPlan?.senderName">
            <svc-smart-user-avatar
              [ids]="actionPlan?.responsibleId || ''"
              [size]="24"
              [fallbackName]="actionPlan?.senderName"
            />
          </div>
        </div>

        <div class="flex flex-col gap-0.5 leading-tight">
          <button
            svc-btn
            class="px-1 -ml-1 max-h-4"
            id="svc-actionplan-button-id"
          >
            @if (tempId && !id) {
              {{ ('Rascunho' | transloco).toUpperCase() }} {{ actionPlan?.draftNumber }}
            } @else {
              {{ ('Pla' | transloco).toUpperCase() }}-{{ actionPlan?.actionPlanId ?? actionPlan?.planId }}
            }
          </button>

          @let planTitle = (actionPlan?.classified && !actionPlan?.allowed) ? ('Registro de acesso restrito' | transloco) : actionPlan?.planName;
          <p
            class="text-default w-fit text-sm break-words line-clamp-2"
            [matTooltip]="planTitle"
          >
            {{ planTitle }}
          </p>
        </div>
      </div>

      <div class="flex flex-col gap-1 items-end justify-center">
        <div class="flex items-center gap-0.5">
          <svc-totals-status
            classColor="text-default"
            [referenceId]="actionPlan.planId"
            [configTypeId]="'A59245C1-7D4E-4B3A-9F2C-1E8D7C6B5A40'"
            [available]="{ comments: true }"
            [rotate]="{ comments: true }"
          />
        </div>

        <svc-status-badge
          class="items-start"
          [badgeData]="{
            description: actionPlanStatusName[actionPlan?.statusId],
            type: actionPlanStatusType[actionPlan?.statusId],
            size: 'small',
          }"
        />

        <p class="text-default text-xs">{{ getDelayedDaysLabel(actionPlan) }}</p>
      </div>
    </div>
  </div>

  <div
    class="justify-end items-center -mx-2 border-t border-gray-300"
    *ngIf="showPagination"
    [style.width]="'calc(100% + 1rem)'"
  >
    <svc-paginate
      [current]="pageIndex"
      [totalRegisters]="totalRegisters"
      [pageSize]="pageSize"
      [showPageSize]="false"
      (onPageChanged)="onPageChange($event)"
    />
  </div>

  <div
    class="svc-data-loading absolute inset-0 flex items-center justify-center"
    *ngIf="isLoading && actionsPlans?.length"
  >
    <mat-spinner diameter="30" />
  </div>
</div>

<div
  class="flex items-center justify-center"
  [class]="classLoading"
  *ngIf="isLoading && !actionsPlans?.length"
>
  <mat-spinner diameter="30"></mat-spinner>
</div>
